export default "__VITE_ASSET___8j3WtS7__"